export var notificationDTOToParams = function (dto) {
    var page = dto.page ? "&page=".concat(dto.page) : '';
    var pageSize = dto.pageSize ? "&pageSize=".concat(dto.pageSize) : '';
    var onlyUnread = dto.onlyUnread ? '&onlyUnread=true' : '';
    var olderThanTimestamp = dto.olderThanTimestamp ? "&olderThanTimestamp=".concat(dto.olderThanTimestamp) : '';
    return "".concat(olderThanTimestamp).concat(pageSize).concat(page).concat(onlyUnread).replace('&', '?');
};
export var createWebNotificationsApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/web-notifications");
    var webNotificationsApi = {
        getNotifications: function (dto) {
            var params = notificationDTOToParams(dto);
            return http.get("".concat(url).concat(params));
        },
        getUnseenCount: function () {
            return http.get("".concat(url, "/unseen/count"));
        },
        resetUnseenCount: function () {
            return http.post("".concat(url, "/unseen/reset"), {});
        },
        setReadStatus: function (dto) {
            return http.post("".concat(url, "/").concat(dto.id, "/setReadStatus"), dto);
        },
        markAllRead: function () {
            return http.post("".concat(url, "/markRead"), {});
        },
        createAnnouncement: function (dto) {
            return http.post("".concat(url, "/announcements"), dto);
        }
    };
    return webNotificationsApi;
};
//# sourceMappingURL=index.js.map